import React from "react";

const Imprint = () => {
  return (
    <div className="article-container" id="imprint-container">
      <h2>Imprint</h2>
      <div>
        <h3>Informationspflicht laut § 5 TMG.</h3>
        <h4>Kontaktdaten des Verantwortlichen für Datenschutz</h4>
        <p>
          Sollten Sie Fragen zum Datenschutz haben, finden Sie nachfolgend die
          Kontaktdaten der verantwortlichen Person bzw. Stelle:
        </p>
        <ul>
          <li>André Kalnassy</li>
          <li>Saarländer Str. 17</li>
          <li>04179 Leipzig</li>
          <li>Deutschland</li>
        </ul>
      </div>
      <hr />
      <h4>EU-Streitschlichtung</h4>
      <p>
        Gemäß Verordnung über Online-Streitbeilegung in
        Verbraucherangelegenheiten (ODR-Verordnung) möchten wir Sie über die
        Online-Streitbeilegungsplattform (OS-Plattform) informieren. Verbraucher
        haben die Möglichkeit, Beschwerden an die Online
        Streitbeilegungsplattform der Europäischen Kommission unter
        http://ec.europa.eu/odr?tid=321289659 zu richten. Die dafür notwendigen
        Kontaktdaten finden Sie oberhalb in# unserem Impressum.
      </p>
      <p>
        Wir möchten Sie jedoch darauf hinweisen, dass wir nicht bereit oder
        verpflichtet sind, an Streitbeilegungsverfahren vor einer
        Verbraucherschlichtungsstelle teilzunehmen.
      </p>
      <h4>Haftung für Inhalte dieser Website</h4>
      <p>
        Wir entwickeln die Inhalte dieser Webseite ständig weiter und bemühen
        uns korrekte und aktuelle Informationen bereitzustellen. Laut
        Telemediengesetz (TMG) §7 (1) sind wir als Diensteanbieter für eigene
        Informationen, die wir zur Nutzung bereitstellen, nach den allgemeinen
        Gesetzen verantwortlich. Leider können wir keine Haftung für die
        Korrektheit aller Inhalte auf dieser Webseite übernehmen, speziell für
        jene die seitens Dritter bereitgestellt wurden. Als Diensteanbieter im
        Sinne der §§ 8 bis 10 sind wir nicht verpflichtet, die von ihnen
        übermittelten oder gespeicherten Informationen zu überwachen oder nach
        Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
      </p>
      <p>
        Unsere Verpflichtungen zur Entfernung von Informationen oder zur
        Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen
        aufgrund von gerichtlichen oder behördlichen Anordnungen bleiben auch im
        Falle unserer Nichtverantwortlichkeit nach den §§ 8 bis 10 unberührt.
      </p>
      <p>
        Sollten Ihnen problematische oder rechtswidrige Inhalte auffallen, bitte
        wir Sie uns umgehend zu kontaktieren, damit wir die rechtswidrigen
        Inhalte entfernen können. Sie finden die Kontaktdaten im Impressum.
      </p>
      <h4>Haftung für Links auf dieser Website</h4>
      <p>
        Unsere Webseite enthält Links zu anderen Webseiten für deren Inhalt wir
        nicht verantwortlich sind. Haftung für verlinkte Websites besteht für
        uns nicht, da wir keine Kenntnis rechtswidriger Tätigkeiten hatten und
        haben, uns solche Rechtswidrigkeiten auch bisher nicht aufgefallen sind
        und wir Links sofort entfernen würden, wenn uns Rechtswidrigkeiten
        bekannt werden.
      </p>
      <p>
        Wenn Ihnen rechtswidrige Links auf unserer Website auffallen, bitte wir
        Sie uns zu kontaktieren. Sie finden die Kontaktdaten im Impressum.
      </p>
      <h4>Urheberrechtshinweis</h4>
      <p>
        Alle Inhalte dieser Webseite (Bilder, Fotos, Texte, Videos) unterliegen
        dem Urheberrecht der Bundesrepublik Deutschland. Bitte fragen Sie uns
        bevor Sie die Inhalte dieser Website verbreiten, vervielfältigen oder
        verwerten wie zum Beispiel auf anderen Websites erneut veröffentlichen.
        Falls notwendig, werden wir die unerlaubte Nutzung von Teilen der
        Inhalte unserer Seite rechtlich verfolgen.
      </p>
      <p>
        Sollten Sie auf dieser Webseite Inhalte finden, die das Urheberrecht
        verletzen, bitten wir Sie uns zu kontaktieren.
      </p>
      <p>
        Die Bilderrechte liegen bei den folgenden Fotografen und Unternehmen:
        Katharina Gerhardt
      </p>
      <p>Alle Texte sind urheberrechtlich geschützt.</p>
      <p>Coding: André Kalnassy</p>
      <hr />
      <h3>Privacy Police</h3>
      <p>Diese Datenschutzerklärung klärt Sie über die Art, den Umfang und Zweck
      der Verarbeitung von personenbezogenen Daten (nachfolgend kurz „Daten“) im
      Rahmen der Erbringung unserer Leistungen sowie innerhalb unseres
      Onlineangebotes und der mit ihm verbundenen Webseiten, Funktionen und
      Inhalte sowie externen Onlinepräsenzen, wie z.B. unser Social Media
      Profile auf (nachfolgend gemeinsam bezeichnet als „Onlineangebot“). Im
      Hinblick auf die verwendeten Begrifflichkeiten, wie z.B. „Verarbeitung“
      oder „Verantwortlicher“ verweisen wir auf die Definitionen im Art. 4 der
      Datenschutzgrundverordnung (DSGVO).</p>
      <ul>
        <li>Verantwortlicher</li>
        <li>André Kalnassy</li>
        <li>Saarländer Str. 17</li>
        <li>04179 Leipzig</li>
        <li>Deutschland</li>
      </ul>
      <h4>Onlinepräsenzen in sozialen Medien</h4>
      <p>
        Wir unterhalten Onlinepräsenzen innerhalb sozialer Netzwerke und
        Plattformen, um mit den dort aktiven Kunden, Interessenten und Nutzern
        kommunizieren und sie dort über unsere Leistungen informieren zu können.
      </p>
      <p>
        Wir weisen darauf hin, dass dabei Daten der Nutzer außerhalb des Raumes
        der Europäischen Union verarbeitet werden können. Hierdurch können sich
        für die Nutzer Risiken ergeben, weil so z.B. die Durchsetzung der Rechte
        der Nutzer erschwert werden könnte. Im Hinblick auf US-Anbieter die
        unter dem Privacy-Shield zertifiziert sind, weisen wir darauf hin, dass
        sie sich damit verpflichten, die Datenschutzstandards der EU
        einzuhalten.
      </p>
      <p>
        Ferner werden die Daten der Nutzer im Regelfall für Marktforschungs- und
        Werbezwecke verarbeitet. So können z.B. aus dem Nutzungsverhalten und
        sich daraus ergebenden Interessen der Nutzer Nutzungsprofile erstellt
        werden. Die Nutzungsprofile können wiederum verwendet werden, um z.B.
        Werbeanzeigen innerhalb und außerhalb der Plattformen zu schalten, die
        mutmaßlich den Interessen der Nutzer entsprechen. Zu diesen Zwecken
        werden im Regelfall Cookies auf den Rechnern der Nutzer gespeichert, in
        denen das Nutzungsverhalten und die Interessen der Nutzer gespeichert
        werden. Ferner können in den Nutzungsprofilen auch Daten unabhängig der
        von den Nutzern verwendeten Geräte gespeichert werden (insbesondere wenn
        die Nutzer Mitglieder der jeweiligen Plattformen sind und bei diesen
        eingeloggt sind).
      </p>
      <p>
        Die Verarbeitung der personenbezogenen Daten der Nutzer erfolgt auf
        Grundlage unserer berechtigten Interessen an einer effektiven
        Information der Nutzer und Kommunikation mit den Nutzern gem. Art. 6
        Abs. 1 lit. f. DSGVO. Falls die Nutzer von den jeweiligen Anbietern der
        Plattformen um eine Einwilligung in die vorbeschriebene
        Datenverarbeitung gebeten werden, ist die Rechtsgrundlage der
        Verarbeitung Art. 6 Abs. 1 lit. a., Art. 7 DSGVO.
      </p>
      <p>
        Für eine detaillierte Darstellung der jeweiligen Verarbeitungen und der
        Widerspruchsmöglichkeiten (Opt-Out), verweisen wir auf die nachfolgend
        verlinkten Angaben der Anbieter.
      </p>
      <p>
        Auch im Fall von Auskunftsanfragen und der Geltendmachung von
        Nutzerrechten, weisen wir darauf hin, dass diese am effektivsten bei den
        Anbietern geltend gemacht werden können. Nur die Anbieter haben jeweils
        Zugriff auf die Daten der Nutzer und können direkt entsprechende
        Maßnahmen ergreifen und Auskünfte geben. Sollten Sie dennoch Hilfe
        benötigen, dann können Sie sich an uns wenden.
      </p>
      <p>
        - Facebook, -Seiten, -Gruppen, (Facebook Ireland Ltd., 4 Grand Canal
        Square, Grand Canal Harbour, Dublin 2, Irland) auf Grundlage einer
        Vereinbarung über gemeinsame Verarbeitung personenbezogener Daten -
        Datenschutzerklärung: https://www.facebook.com/about/privacy/, speziell
        für Seiten:
        https://www.facebook.com/legal/terms/information_about_page_insights_data
        , Opt-Out: https://www.facebook.com/settings?tab=ads und
        http://www.youronlinechoices.com, Privacy Shield:
        https://www.privacyshield.gov/participant?id=a2zt0000000GnywAAC&status=Active.
      </p>
      <p>
        - Google/ YouTube (Google LLC, 1600 Amphitheatre Parkway, Mountain View,
        CA 94043, USA) – Datenschutzerklärung:
        https://policies.google.com/privacy, Opt-Out:
        https://adssettings.google.com/authenticated, Privacy Shield:
        https://www.privacyshield.gov/participant?id=a2zt000000001L5AAI&status=Active.
      </p>
      <p>
        - Instagram (Instagram Inc., 1601 Willow Road, Menlo Park, CA, 94025,
        USA) – Datenschutzerklärung/ Opt-Out:
        http://instagram.com/about/legal/privacy/.
      </p>
      <h4>Einbindung von Diensten und Inhalten Dritter</h4>
      <p>
        Wir setzen innerhalb unseres Onlineangebotes auf Grundlage unserer
        berechtigten Interessen (d.h. Interesse an der Analyse, Optimierung und
        wirtschaftlichem Betrieb unseres Onlineangebotes im Sinne des Art. 6
        Abs. 1 lit. f. DSGVO) Inhalts- oder Serviceangebote von Drittanbietern
        ein, um deren Inhalte und Services, wie z.B. Videos oder Schriftarten
        einzubinden (nachfolgend einheitlich bezeichnet als “Inhalte”).
      </p>
      <p>
        Dies setzt immer voraus, dass die Drittanbieter dieser Inhalte, die
        IP-Adresse der Nutzer wahrnehmen, da sie ohne die IP-Adresse die Inhalte
        nicht an deren Browser senden könnten. Die IP-Adresse ist damit für die
        Darstellung dieser Inhalte erforderlich. Wir bemühen uns nur solche
        Inhalte zu verwenden, deren jeweilige Anbieter die IP-Adresse lediglich
        zur Auslieferung der Inhalte verwenden. Drittanbieter können ferner so
        genannte Pixel-Tags (unsichtbare Grafiken, auch als "Web Beacons"
        bezeichnet) für statistische oder Marketingzwecke verwenden. Durch die
        "Pixel-Tags" können Informationen, wie der Besucherverkehr auf den
        Seiten dieser Website ausgewertet werden. Die pseudonymen Informationen
        können ferner in Cookies auf dem Gerät der Nutzer gespeichert werden und
        unter anderem technische Informationen zum Browser und Betriebssystem,
        verweisende Webseiten, Besuchszeit sowie weitere Angaben zur Nutzung
        unseres Onlineangebotes enthalten, als auch mit solchen Informationen
        aus anderen Quellen verbunden werden.
      </p>
      <h4>Google Fonts</h4>
      <p>
        Wir binden die Schriftarten des Anbieters Google LLC,
        1600 Amphitheatre Parkway, Mountain View, CA 94043, USA, ein.
        Datenschutzerklärung: https://www.google.com/policies/privacy/, Opt-Out:
        https://adssettings.google.com/authenticated.
      </p>
    </div>
  );
};
export default Imprint;
